<div
  *ngIf="!!items?.length"
  class="scroll-container"
  infiniteScroll
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="100"
  [scrollWindow]="false"
  [infiniteScrollDisabled]="!hasMoreData"
  (scrolled)="triggerLoadMore()"
>
  <table>
    <thead>
      <tr>
        <th>Full name</th>
        <th>Email</th>
        <th>Participated</th>
      </tr>
    </thead>
    <tbody id="tbody">
      <tr *ngFor="let item of items; trackBy: trackById">
        <td>
          <div class="name-cell">
            {{ item?.first_name }} {{ item?.last_name }}
          </div>
        </td>
        <td>
          <span class="email-text">{{ item?.email }}</span>
        </td>
        <td>
          <span [ngClass]="getParticipateClass(item?.isParticipated)"
            ><span
              [ngClass]="getParticipateDotClass(item?.isParticipated)"
            ></span
            >{{ item?.isParticipated ? "Yes" : "No" }}</span
          >
        </td>
      </tr>
    </tbody>
  </table>

  <div *ngIf="loading">⏳ Loading...</div>

  <!-- <div *ngIf="!hasMoreData">✅ All items loaded!</div> -->
</div>
